import CityPageTemplate from "../city-template/CityPageTemplate";
import { haywardConfig } from "./data";

export default function HaywardPage() {
  return <CityPageTemplate config={haywardConfig} />;
}